import { render, staticRenderFns } from "./DisqualifiedCandidates.vue?vue&type=template&id=408b7db0&scoped=true"
import script from "./DisqualifiedCandidates.vue?vue&type=script&lang=js"
export * from "./DisqualifiedCandidates.vue?vue&type=script&lang=js"
import style0 from "./DisqualifiedCandidates.vue?vue&type=style&index=0&id=408b7db0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408b7db0",
  null
  
)

export default component.exports